import { isString } from "lodash";
import { DiffMethod, diffObject } from "./diffFields";

const parser = new DOMParser();
export const xmlStringDiffer: DiffMethod = (
  initial: unknown,
  cur: unknown,
  reach,
  depth: number = 0,
  nameTraverse: string = ""
): Array<string> => {
  if (isString(initial) && isString(cur)) {
    const getAllPhoneConfig = (d: XMLDocument) => {
      const phoneConfig = d.getElementsByTagName("PHONE_CONFIG").item(0);
      if (!phoneConfig) {
        return {};
      }
      const rootName = phoneConfig.nodeName;
      const fields = Array.from(phoneConfig.children)
        .flatMap(node =>
          node
            .getAttributeNames()
            .map(name => [
              [`${rootName}.${node.nodeName}.${name}`, node.getAttribute(name)]
            ])
        )
        .reduce((a, b) => a.concat(b), []);
      return Object.fromEntries(fields);
    };
    const iXml = parser.parseFromString(initial, "text/xml") as XMLDocument;
    const cXml = parser.parseFromString(cur, "text/xml") as XMLDocument;
    const iAll = getAllPhoneConfig(iXml);
    const cAll = getAllPhoneConfig(cXml);
    return diffObject(iAll, cAll, undefined, depth + 1, nameTraverse);
  }
  return [];
};
